import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getAdvanced } from '../../utils';
export default (node => {
  var html;
  if (node.dataset.decoded) {
    html = node.innerHTML;
    if (process.env.NODE_ENV !== 'production') {
      console.warn('PageBuilder HTML content was unescaped! This may be a Magento configuration error.');
    }
  } else {
    var dom = new DOMParser().parseFromString('<!doctype html><body>' + node.textContent, 'text/html');
    html = dom.body.innerHTML;
  }
  return _objectSpread({
    html
  }, getAdvanced(node));
});